<template>
    <div class="map__quick-filters__wrapper">
        <ul class="map__quick-filters__primary-filters">
            <li
                v-for="filter in filters"
                :key="filter.name"
                @click="togglePrimaryFilter(filter)"
                :class="[{ selected: isSelectedPrimaryFilter(filter) }]"
            >
                <figure>
                    <span class="map__quick-filters__filter-icon-wrapper">
                        <svg
                            :alt="filter.name"
                            class="map__quick-filters__filter-icon"
                        >
                            <use
                                :xlink:href="`${icons[filter.icon]}#icon`"
                            ></use>
                        </svg>
                    </span>
                    <figcaption class="map__quick-filters__filter-label">
                        {{ filter.name }}
                    </figcaption>
                </figure>
            </li>
        </ul>
        <ul
            v-if="selectedPrimaryFilter && selectedPrimaryFilter.children"
            class="map__quick-filters__secondary-filters"
        >
            <li
                v-for="filter in selectedPrimaryFilter.children"
                :key="filter.name"
                @click="selectSecondaryFilter(filter)"
                :class="[{ selected: isSelectedSecondaryFilter(filter) }]"
            >
                <figure>
                    <span class="map__quick-filters__filter-icon-wrapper">
                        <svg
                            :alt="filter.name"
                            class="map__quick-filters__filter-icon"
                        >
                            <use
                                :xlink:href="`${icons[filter.icon]}#icon`"
                            ></use>
                        </svg>
                    </span>
                    <figcaption class="map__quick-filters__filter-label">
                        {{ filter.name }}
                    </figcaption>
                </figure>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    props: {
        selectedPrimaryFilter: {
            default: null,
        },
    },
    data() {
        return {
            icons: window.here.icons,
            filters: [
                {
                    name: 'Weigh Stations',
                    icon: 'place-weight',
                    category: 'weigh_station',
                },
                {
                    name: 'Truck Stops',
                    icon: 'place-truckstop',
                    category: 'truck_stop',
                    children: [
                        {
                            name: 'Truck Stops',
                            icon: 'place-truckstop',
                            active: true,
                            category: 'truck_stop',
                        },
                        {
                            name: 'Pilot & Flying J',
                            icon: 'brand-pilot',
                            active: true,
                            category: 'pilot',
                        },
                        {
                            name: 'Loves',
                            icon: 'brand-loves',
                            active: true,
                            category: 'loves',
                        },
                        {
                            name: 'TA & Petro',
                            icon: 'brand-ta',
                            active: true,
                            category: 'ta',
                        },
                        {
                            name: 'Kwik Trip',
                            icon: 'brand-kwik',
                            active: true,
                            category: 'kwik',
                        },
                        {
                            name: 'Fuel stations',
                            icon: 'place-fuel',
                            active: true,
                            category: 'gas',
                        },
                    ],
                },
                {
                    name: 'Diesel',
                    icon: 'place-fuel',
                    category: 'gas',
                    children: [
                        {
                            name: 'Truck Stops',
                            icon: 'place-truckstop',
                            active: true,
                            category: 'truck_stop',
                        },
                        {
                            name: 'Pilot & Flying J',
                            icon: 'brand-pilot',
                            active: true,
                            category: 'pilot',
                        },
                        {
                            name: 'Loves',
                            icon: 'brand-loves',
                            active: true,
                            category: 'loves',
                        },
                        {
                            name: 'TA & Petro',
                            icon: 'brand-ta',
                            active: true,
                            category: 'ta',
                        },
                        {
                            name: 'Kwik Trip',
                            icon: 'brand-kwik',
                            active: true,
                            category: 'kwik',
                        },
                        {
                            name: 'Fuel stations',
                            icon: 'place-fuel',
                            active: true,
                            category: 'gas',
                        },
                    ],
                },
                {
                    name: 'Parking',
                    icon: 'place-parking',
                    category: 'parking',
                    children: [
                        {
                            name: 'Truck Stops',
                            icon: 'place-truckstop',
                            active: true,
                            category: 'truck_stop',
                        },
                        {
                            name: 'Pilot & Flying J',
                            icon: 'brand-pilot',
                            active: true,
                            category: 'pilot',
                        },
                        {
                            name: 'Loves',
                            icon: 'brand-loves',
                            active: true,
                            category: 'loves',
                        },
                        {
                            name: 'TA & Petro',
                            icon: 'brand-ta',
                            active: true,
                            category: 'ta',
                        },
                        {
                            name: 'Kwik Trip',
                            icon: 'brand-kwik',
                            active: true,
                            category: 'kwik',
                        },
                        {
                            name: 'Walmarts',
                            icon: 'brand-walmart',
                            active: true,
                            category: 'walmart',
                        },
                        {
                            name: 'Rest Areas',
                            icon: 'place-restarea',
                            active: true,
                            category: 'rest_area',
                        },
                        {
                            name: 'Parking',
                            icon: 'place-parking',
                            active: true,
                            category: 'parking',
                        },
                    ],
                },
                {
                    name: 'Cat Scales',
                    icon: 'cat-scale',
                    category: 'cat_scale',
                    children: [
                        {
                            name: 'Scales',
                            icon: 'cat-scale',
                            active: true,
                            category: 'cat_scale',
                        },
                        {
                            name: 'Truck Stops',
                            icon: 'place-truckstop',
                            active: true,
                            category: 'cat_scale',
                        },
                        {
                            name: 'Pilot & Flying J',
                            icon: 'brand-pilot',
                            active: true,
                            category: 'pilot',
                        },
                        {
                            name: 'Loves',
                            icon: 'brand-loves',
                            active: true,
                            category: 'loves',
                        },
                        {
                            name: 'TA & Petro',
                            icon: 'brand-ta',
                            active: true,
                            category: 'ta',
                        },
                        {
                            name: 'Kwik Trip',
                            icon: 'brand-kwik',
                            active: true,
                            category: 'kwik',
                        },
                        {
                            name: 'Walmarts',
                            icon: 'brand-walmart',
                            active: true,
                            category: 'walmart',
                        },
                        {
                            name: 'Rest Areas',
                            icon: 'place-restarea',
                            active: true,
                            category: 'rest_area',
                        },
                        {
                            name: 'Parking',
                            icon: 'place-parking',
                            active: true,
                            category: 'parking',
                        },
                    ],
                },
            ],
            // selectedPrimaryFilter: null,
        };
    },
    methods: {
        togglePrimaryFilter(filter) {
            if (this.isSelectedPrimaryFilter(filter)) {
                this.$emit('selectprimaryfilter', null);
            } else {
                this.selectPrimaryFilter(filter);
            }
        },
        selectPrimaryFilter(filter) {
            this.$emit('selectprimaryfilter', filter);
        },
        isSelectedPrimaryFilter(filter) {
            return this.selectedPrimaryFilter === filter;
        },
        selectSecondaryFilter(filter) {
            if (!this.selectedPrimaryFilter) {
                return false;
            }

            if (!this.selectedPrimaryFilter.children) {
                return false;
            }

            this.selectedPrimaryFilter.children.map((item) => {
                const local = item;
                if (local === filter) {
                    local.active = !local.active;
                    this.$emit('selectsecondaryfilter', local);
                }
                return local;
            });

            return typeof found !== 'undefined';
        },
        isSelectedSecondaryFilter(filter) {
            return filter.active;
        },
    },
};
</script>
<style lang="scss">
@mixin map-ui-hover() {
    transition: background-color 300ms;

    &:hover {
        background-color: #eee2d9;
    }
}

.map__quick-filters__wrapper {
    position: fixed;
    top: 17px;
    right: 19px;
    background: #fff;
    // border-radius: 4px 4px 0 0;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 6px 15px 0 rgba(0, 0, 0, 0.15);

    @media screen and (max-width: 768px) {
        position: static;
        box-shadow: none;
    }
}

.map__quick-filters__primary-filters,
.map__quick-filters__secondary-filters {
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: flex;
    max-width: 448px;

    @media screen and (max-width: 768px) {
        max-width: 100%;
    }

    figure {
        padding-top: 12px;
        margin: 0;
    }

    li {
        flex: 1;
        width: 66px;
        height: 66px;
        text-align: center;
        cursor: pointer;
        color: #958983;
        user-select: none;

        @media screen and (max-width: 768px) {
            height: auto;
        }
    }

    &.map__quick-filters__primary-filters {
        li {
            @include map-ui-hover;
            width: 100px;
            max-width: 100px;
            height: 84px;

            @media screen and (max-width: 768px) {
                width: 20%;
                max-width: 20%;
                height: auto;
            }
        }
    }

    &.map__quick-filters__secondary-filters {
        background-color: #ac9f96;
        padding-left: 12px;
        padding-right: 12px;
        width: 100%;
        flex-wrap: wrap;
        li {
            max-width: 16.66%;
            flex-basis: 16.66%;
        }
    }
}

.map__quick-filters__filter-icon {
    width: 24px;
    height: 24px;
}

.map__quick-filters__secondary-filters {
    .map__quick-filters__filter-icon {
        width: 20px;
        height: 20px;
    }
}

.map__quick-filters__filter-icon-wrapper {
    display: inline-block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid rgba(36, 28, 23, 0.12);
    color: rgba(78, 58, 48, 0.6);
    padding: 6px 8px;
}

.map__quick-filters__secondary-filters {
    .map__quick-filters__filter-icon-wrapper {
        width: 28px;
        height: 24px;
        padding: 0 2px;
    }
}

.map__quick-filters__secondary-filters {
    .map__quick-filters__filter-icon-wrapper {
        border: 1px solid transparent;
        color: #eee2d9;
    }

    .map__quick-filters__filter-label {
        color: #eee2d9;
    }

    .selected {
        .map__quick-filters__filter-icon-wrapper {
            border: 1px solid transparent;
            background-color: transparent;
            color: #fff;
        }

        .map__quick-filters__filter-label {
            color: #fff;
        }
    }
}

.map__quick-filters__filter-label {
    font-size: 14px;
    white-space: nowrap;

    @media screen and (max-width: 768px) {
        white-space: unset;
    }
}

.map__quick-filters__secondary-filters {
    .map__quick-filters__filter-label {
        font-size: 12px;
    }
}

.selected {
    .map__quick-filters__filter-icon-wrapper {
        color: #fff;
        background-color: #c8532b;
        border-color: #c8532b;
    }

    .map__quick-filters__filter-label {
        color: #c8532b;
    }
}
</style>
